import React from 'react'
import { useTranslation } from 'next-i18next/pages'
import Link from 'next/link'

export const ErrorPage = (): React.ReactElement => {
    const { t } = useTranslation(['common'])

    return (
        <div className="page-error-container">
            <h2>{t('Something went wrong!')}</h2>
            <p>
                {t('Please')}{' '}
                <Link href="/">{t('return to our homepage')}</Link>{' '}
                {t('to continue shopping.')}
            </p>
        </div>
    )
}
